import { HttpErrorResponse } from '@angular/common/http';
import { Component, computed, effect, inject, model, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { IGremium } from 'src/app/types/IGremium';
import { IWirtschaftsplanViewmodel, WirtschaftsplanViewmodel } from 'src/app/types/viewmodels/wirtschaftsplan.viewmodel';
import { IWirtschaftsplan } from 'src/app/types/IWirtschaftsplan';

@Component({
  selector: 'app-wirtschafsplan-erstellen',
  templateUrl: './wirtschaftsplan-erstellen.component.html',
  styleUrl: './wirtschaftsplan-erstellen.component.css'
})
export class WirtschaftsplanErstellenComponent {

  dataWip: IWirtschaftsplanViewmodel = WirtschaftsplanViewmodel.default
  dataForm = {
    verwaltungsbereichId: signal<number>(0),
    plangebietId: signal<number>(0),
    gremiumId: signal<number | undefined>(0),
    wirtschaftsplanId: signal<number | undefined>(0),
  }
  dataGremien = computed<IGremium[]> (()=> {
    if ([1, 3].includes(this.dataForm.plangebietId()) && this.dataForm.verwaltungsbereichId() == 1)
      return this.dataWip.gremien;
    else
      return this.dataWip.gremien.filter(gremium => gremium.id == 2);
  });
  dataWirtschaftsplaene = computed<IWirtschaftsplan[]>(()=> {
    // Gremium AR oder Plangebiet Billebogen oder Science City
    if (this.dataForm.gremiumId() == 2 || [2, 4].includes(this.dataForm.plangebietId()) || this.dataForm.verwaltungsbereichId() != 1)
      return this.dataWip.wirtschaftsplaenejahre;
    else
      return this.dataWip.wirtschaftsplaene;
  });

  startYear = computed<number>(()=> this.dataForm.wirtschaftsplanId() ?? (new Date().getFullYear() + 1));
  isBNKVisible = computed<boolean>(()=> (this.dataForm.verwaltungsbereichId() == 1 && [1, 3].includes(this.dataForm.plangebietId())));
  isJahr23Visible = computed<boolean>(()=> (this.dataForm.verwaltungsbereichId() == 1 && this.dataForm.gremiumId() == 5 && [1, 3].includes(this.dataForm.plangebietId())));
  isJahr1Visible = computed<boolean>(()=> (this.dataForm.verwaltungsbereichId() != 1 || (this.dataForm.gremiumId() == 2 && [2, 4].includes(this.dataForm.plangebietId()))));
  labelYearPlus1 = computed<string>(()=> "Jahr " + this.startYear().toString());
  labelYearPlus2 = computed<string>(()=> "Jahr " + (this.startYear() + 1).toString());
  labelYearPlus3 = computed<string>(()=> "Jahr " + (this.startYear() + 2).toString());
  isDataProgressing = signal<boolean>(false);

  private dataService = inject(DataService);
  private dialogService = inject(DialogService);
  readonly dialogRef = inject(MatDialogRef<WirtschaftsplanErstellenComponent>);

  constructor() {

    effect(() => {
      this.dataWip.wirtschaftsplanerstellung.verwaltungsbereich = this.dataForm.verwaltungsbereichId();
      this.dataWip.wirtschaftsplanerstellung.verwaltungsbereichBezeichnung = this.dataWip.verwaltungsbereiche.filter(verwaltungsbereich => verwaltungsbereich.id == this.dataForm.verwaltungsbereichId())[0]?.name;
      this.dataForm.gremiumId.set(undefined);
      this.dataForm.wirtschaftsplanId.set(undefined);
    }, { allowSignalWrites: true });

    effect(() => {
      this.dataWip.wirtschaftsplanerstellung.plangebiet = this.dataForm.plangebietId();
      this.dataWip.wirtschaftsplanerstellung.plangebietBezeichnung = this.dataWip.plangebiete.filter(plangebiet => plangebiet.id == this.dataForm.plangebietId())[0]?.name;  
      this.dataForm.gremiumId.set(undefined);
      this.dataForm.wirtschaftsplanId.set(undefined);
    }, { allowSignalWrites: true });

    effect(() => {
      this.dataWip.wirtschaftsplanerstellung.gremium = this.dataForm.gremiumId();
        this.dataWip.wirtschaftsplanerstellung.gremiumBezeichnung = this.dataWip.gremien.filter(gremium => gremium.id == this.dataForm.gremiumId())[0]?.name;
      this.dataForm.wirtschaftsplanId.set(undefined);  
    }, { allowSignalWrites: true });

    effect(() => {
      this.dataWip.wirtschaftsplanerstellung.wip = this.dataForm.wirtschaftsplanId();
        this.dataWip.wirtschaftsplanerstellung.bezeichnungWIP = this.dataWip.wirtschaftsplaene.filter(wip => wip.id == this.dataForm.wirtschaftsplanId())[0]?.wip; 
    }, { allowSignalWrites: true });
   
    effect(() => {
      document.body.style.cursor = this.isDataProgressing() ? 'wait' : 'default';
    });
   
  }

  ngOnInit(): void {

    this.dataService.readWirtschaftsplanViewModel().subscribe((data) => {
      this.dataWip = data;
      this.dataForm.verwaltungsbereichId.set(this.dataWip.wirtschaftsplanerstellung.verwaltungsbereich);
      this.dataForm.plangebietId.set(this.dataWip.wirtschaftsplanerstellung.plangebiet);
      this.dataForm.gremiumId.set(this.dataWip.wirtschaftsplanerstellung.gremium);
      this.dataForm.wirtschaftsplanId.set(this.dataWip.wirtschaftsplanerstellung.wip); 
    });
  }

  SaveButtonClicked(): void {
    // POST
    var erstellung = this.dataWip.wirtschaftsplanerstellung;
    this.isDataProgressing.set(true);
    // set global wait cursor while the save is in progress
    this.dataService.createWirtschaftsplan(erstellung).subscribe({
      next: (data) => {
        this.dialogService.showInfoDialog('Der Wirtschaftsplan wurde erfolgreich erstellt.', 'Anlage des Wirtschaftsplans');
        this.isDataProgressing.set(false);
      },
      error: (err: HttpErrorResponse) => {
        this.dialogService.showInfoDialog('Fehler beim Erstellen des Wirtschaftsplans.', 'Fehler');
      }
    });
  }

  DeleteButtonClicked(): void {
    // DELETE
    var erstellung = this.dataWip.wirtschaftsplanerstellung;   
    this.isDataProgressing.set(true);
    this.dataService.deleteWirtschaftsplan(erstellung).subscribe({
      next: (data) => {
        this.dialogService.showInfoDialog('Der Wirtschaftsplan wurde erfolgreich gelöscht.', 'Löschen des Wirtschaftsplans');
        this.isDataProgressing.set(false);
      },
      error: (err: HttpErrorResponse) => {
        this.dialogService.showInfoDialog('Fehler beim Erstellen des Wirtschaftsplans.', 'Fehler');
      }
    });
  }

  CloseButtonClick(): void {
    this.dialogRef.close();
  }

}
